module.exports = __webpack_public_path__ + "img/icon_message_select.080d13d7.png";